import { getImageObjectUrl } from '@/utils/upload/imageObjectUrls';
import { getConfigurationFilterId } from './getConfigurationFilterId';

export function getConfigurationFilterObjectUrl(cid: number) {
  return getImageObjectUrl(getConfigurationFilterId(cid));
}
